import React, { useState } from "react";
import { Button, Typography } from "@mui/material";
import useScopedTranslation from "../../../hooks/useScopedTranslation";
import HTMLEditor from "../../../components/HtmlEditor/HtmlEditor";

export default ({ disabled, acknowledgementText, onUpdate }) => {
  const t = useScopedTranslation("policySettings");
  const defaultAcknowledgement = t("defaultAcknowledgement");
  const [value, setValue] = useState(
    acknowledgementText || defaultAcknowledgement
  );

  const handleChange = () => {
    if (value !== acknowledgementText) {
      onUpdate({ policyAcknowledgementText: value });
    }
  };

  const restoreDefault = () => {
    setValue(defaultAcknowledgement);
    onUpdate({ policyAcknowledgementText: defaultAcknowledgement });
  };

  return (
    <>
      <Typography variant="h5">{t("acknowledgementTitle")}</Typography>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ flex: "1" }}>
          <HTMLEditor
            value={value}
            onChange={value => setValue(value)}
            onBlur={() => handleChange()}
            plugins={["lists", "link", "code"]}
            disabled={disabled}
          ></HTMLEditor>
        </div>

        <Button
          color="primary"
          disabled={disabled}
          style={{ marginLeft: "64px", marginRight: "32px" }}
          onClick={() => restoreDefault()}
        >
          {t("restoreDefault")}
        </Button>
      </div>
    </>
  );
};
